import React from 'react';

import { useIntl } from 'react-intl-next';

import EyeOpenStrikethroughIcon from '@atlaskit/icon/core/eye-open-strikethrough';
import { ButtonMenuItem } from '@atlaskit/navigation-system/side-nav-items/button-menu-item';

import { messages } from './messages';
import { useMoreMenuDragAndDrop } from './use-more-menu-drag-and-drop';

export function HideFromSidebarButton() {
	const { formatMessage } = useIntl();
	const { dropIndicator, dropTargetRef, moreButtonRef } = useMoreMenuDragAndDrop();

	return (
		<ButtonMenuItem
			elemBefore={<EyeOpenStrikethroughIcon label="" />}
			ref={moreButtonRef}
			dropIndicator={dropIndicator}
			visualContentRef={dropTargetRef}
		>
			{formatMessage(messages.hideFromSidebar)}
		</ButtonMenuItem>
	);
}
